import * as tslib_1 from "tslib";
import { GraphQueryableInstance, GraphQueryableCollection, defaultPath } from "./graphqueryable";
import { jsS } from "@pnp/common";
var Messages = /** @class */ (function (_super) {
    tslib_1.__extends(Messages, _super);
    function Messages() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Gets a member of the group by id
     *
     * @param id Attachment id
     */
    Messages.prototype.getById = function (id) {
        return new Message(this, id);
    };
    /**
     * Add a message to this collection
     *
     * @param message The message details
     */
    Messages.prototype.add = function (message) {
        return this.postCore({
            body: jsS(message),
        });
    };
    Messages = tslib_1.__decorate([
        defaultPath("messages")
    ], Messages);
    return Messages;
}(GraphQueryableCollection));
export { Messages };
var Message = /** @class */ (function (_super) {
    tslib_1.__extends(Message, _super);
    function Message() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Message;
}(GraphQueryableInstance));
export { Message };
var MailFolders = /** @class */ (function (_super) {
    tslib_1.__extends(MailFolders, _super);
    function MailFolders() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Gets a member of the group by id
     *
     * @param id Attachment id
     */
    MailFolders.prototype.getById = function (id) {
        return new MailFolder(this, id);
    };
    /**
     * Add a mail folder to this collection
     *
     * @param message The message details
     */
    MailFolders.prototype.add = function (mailFolder) {
        return this.postCore({
            body: jsS(mailFolder),
        });
    };
    MailFolders = tslib_1.__decorate([
        defaultPath("mailFolders")
    ], MailFolders);
    return MailFolders;
}(GraphQueryableCollection));
export { MailFolders };
var MailFolder = /** @class */ (function (_super) {
    tslib_1.__extends(MailFolder, _super);
    function MailFolder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MailFolder;
}(GraphQueryableInstance));
export { MailFolder };
var MailboxSettings = /** @class */ (function (_super) {
    tslib_1.__extends(MailboxSettings, _super);
    function MailboxSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MailboxSettings.prototype.update = function (settings) {
        return this.patchCore({
            body: jsS(settings),
        });
    };
    MailboxSettings = tslib_1.__decorate([
        defaultPath("mailboxSettings")
    ], MailboxSettings);
    return MailboxSettings;
}(GraphQueryableInstance));
export { MailboxSettings };
//# sourceMappingURL=messages.js.map